// @flow

import React from "react";
import { Text } from "../../../components/Text";
import { TouchableOpacity, StyleSheet } from "react-native";
import { colors } from "@/app/constants/styles";

interface FilterButtonProps {
  text: string;
  onPress: () => void;
  backgroundColor?: string;
  color?: string;
  testID?: string;
}

const FilterButton: React.FC<FilterButtonProps> = ({
  text,
  onPress,
  backgroundColor = colors.white,
  color = colors.maroon,
  testID,
}) => (
  <TouchableOpacity
    testID={testID || "filterButton"}
    onPress={onPress}
    style={[styles.button, { backgroundColor }]}
  >
    <Text style={[styles.text, { color }]}>{text}</Text>
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  button: {
    paddingHorizontal: 32,
    paddingVertical: 16,
    borderRadius: 8,
    elevation: 2,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.5,
    shadowRadius: 8.84,
  },
  text: {
    fontSize: 16,
    fontWeight: "500",
  },
});

export { FilterButton };
